module.exports = __webpack_public_path__ + "static/media/bnb.f78cb0ac.svg";